import { action, PayloadAction } from 'typesafe-actions';
import { ServicesActionTypes, ServicesState } from './services.types';
import { UseFetchServiceErrors } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { Anything } from '@types';

export const saveSuccessServiceResponse = (data: ServicesState): PayloadAction<string, ServicesState> =>
	action(ServicesActionTypes.saveSuccessServiceResponse, data);

export const saveErrorServiceResponse = (
	error: UseFetchServiceErrors<Anything>
): PayloadAction<string, UseFetchServiceErrors<Anything>> =>
	action(ServicesActionTypes.saveErrorServiceResponse, error);
